import Icon from '@material-ui/icons/Work';

import Create from './Create';
import Edit from './Edit';
import List from './List';
import Show from './Show';

export default {
  name: 'occupation',
  icon: Icon,
  list: List,
  show: Show,
  create: Create,
  edit: Edit,
};
